import React, { Component } from 'react'


export const URL_APP_V2 = process.env.REACT_APP_URL_APP_V2 || 'http://localhost:5120'; //"//comptav2.myjoulebox.com" 
export class IframeV1 extends Component {

  constructor(props) {
    super(props);
    this.iframeRef = React.createRef();
    this.state = {
      refreshTimestamp: Date.now(),
      isReadyToShow: false,
      currentToken: props.token || localStorage.getItem('jwtToken_compta'),
      isLoading: true,
      showIframe: false,
      hasLoadedOnce: false, // Pour éviter les rechargements multiples
    };
  }

  componentDidMount(){
    // Écouter les changements de token dans le localStorage
    this.setupTokenListener();
    
    // Désactiver temporairement la vérification de santé pour éviter les rechargements multiples
    // this.startIframeHealthCheck();
    
    console.log('IframeV1: Composant monté, iframe va se charger avec l\'URL générée');
  }

  componentDidUpdate(prevProps) {
    // Vérifier si le token a changé via les props
    if (prevProps.token !== this.props.token) {
      console.log('IframeV1: Token changé via props, rafraîchissement de l\'iframe');
      
      // Cacher l'iframe pendant le rechargement
      this.setState({ 
        currentToken: this.props.token,
        refreshTimestamp: Date.now(),
        showIframe: false,
        isLoading: true
      }, () => {
        this.clearCacheAndRefresh();
        
        // Réafficher l'iframe après le rechargement
        setTimeout(() => {
          this.setState({ showIframe: true });
        }, 300);
      });
    }
  }

  componentWillUnmount() {
    // Nettoyer l'iframe avant le démontage du composant
    this.clearIframeState();
    // Nettoyer l'écouteur d'événements
    this.removeTokenListener();
    // Arrêter la vérification de santé
    this.stopIframeHealthCheck();
  }

  // Méthode pour écouter les changements de token dans le localStorage
  setupTokenListener = () => {
    // Écouter les événements de stockage pour détecter les changements de token
    window.addEventListener('storage', this.handleStorageChange);
    
    // Écouter les événements personnalisés pour les changements de token
    window.addEventListener('tokenChanged', this.handleTokenChange);
  }

  // Méthode pour supprimer l'écouteur d'événements
  removeTokenListener = () => {
    window.removeEventListener('storage', this.handleStorageChange);
    window.removeEventListener('tokenChanged', this.handleTokenChange);
  }

  // Gérer les changements dans le localStorage
  handleStorageChange = (e) => {
    if (e.key === 'jwtToken_compta' && e.newValue !== this.state.currentToken) {
      console.log('IframeV1: Token changé dans localStorage, rafraîchissement complet de l\'iframe');
      console.log('IframeV1: Ancien token:', this.state.currentToken);
      console.log('IframeV1: Nouveau token:', e.newValue);
      
      // Cacher l'iframe pendant le rechargement
      this.setState({ 
        currentToken: e.newValue,
        refreshTimestamp: Date.now(),
        showIframe: false,
        isLoading: true
      }, () => {
        // Forcer un rechargement complet avec nettoyage de cache
        this.forceCompleteReload();
        
        // Réafficher l'iframe après le rechargement
        setTimeout(() => {
          this.setState({ showIframe: true });
        }, 500);
      });
    }
  }

  // Gérer les événements personnalisés de changement de token
  handleTokenChange = (e) => {
    const newToken = e.detail?.token || localStorage.getItem('jwtToken_compta');
    if (newToken !== this.state.currentToken) {
      console.log('IframeV1: Token changé via événement personnalisé, rafraîchissement complet de l\'iframe');
      console.log('IframeV1: Ancien token:', this.state.currentToken);
      console.log('IframeV1: Nouveau token:', newToken);
      
      // Cacher l'iframe pendant le rechargement
      this.setState({ 
        currentToken: newToken,
        refreshTimestamp: Date.now(),
        showIframe: false,
        isLoading: true
      }, () => {
        // Forcer un rechargement complet avec nettoyage de cache
        this.forceCompleteReload();
        
        // Réafficher l'iframe après le rechargement
        setTimeout(() => {
          this.setState({ showIframe: true });
        }, 500);
      });
    }
  }

  // Vérification périodique de la santé de l'iframe
  startIframeHealthCheck = () => {
    this.healthCheckInterval = setInterval(() => {
      this.checkIframeHealth();
    }, 5000); // Vérifier toutes les 5 secondes
  }

  stopIframeHealthCheck = () => {
    if (this.healthCheckInterval) {
      clearInterval(this.healthCheckInterval);
      this.healthCheckInterval = null;
    }
  }

  checkIframeHealth = () => {
    if (!this.iframeRef.current) return;

    try {
      const iframeDoc = this.iframeRef.current.contentDocument || this.iframeRef.current.contentWindow.document;
      if (iframeDoc && iframeDoc.body) {
        const bodyContent = iframeDoc.body.innerHTML;
        if (bodyContent.trim() === '' || bodyContent.includes('about:blank')) {
          console.warn('IframeV1: Iframe vide détectée, tentative de rechargement');
          this.clearCacheAndRefresh();
        }
      }
    } catch (error) {
      // Si on ne peut pas accéder au contenu (CORS), vérifier l'URL
      const currentSrc = this.iframeRef.current.src;
      if (currentSrc.includes('about:blank')) {
        console.warn('IframeV1: Iframe sur about:blank détectée, tentative de rechargement');
        this.clearCacheAndRefresh();
      }
    }
  }

  refreshIframe = (clearCache = false) => {
    if (this.iframeRef.current) {
      try {
        if (clearCache) {
          // Méthode avec nettoyage de cache : forcer le rechargement depuis le serveur
          this.iframeRef.current.contentWindow.location.reload(true);
          console.log('IframeV1: Iframe rafraîchie avec nettoyage de cache');
        } else {
          // Méthode 1: Recharger le contenu de l'iframe normalement
          this.iframeRef.current.contentWindow.location.reload();
          console.log('IframeV1: Iframe rafraîchie via contentWindow.reload()');
        }
      } catch (error) {
        // Méthode 2: Si l'accès direct est bloqué (CORS), on change l'URL avec timestamp
        console.log('IframeV1: Accès direct bloqué, rafraîchissement via changement d\'URL');
        this.setState({ refreshTimestamp: Date.now() });
      }
    } else {
      // Si l'iframe n'est pas encore montée, forcer le re-render avec un nouveau timestamp
      console.log('IframeV1: Iframe pas encore montée, forcer le re-render');
      this.setState({ refreshTimestamp: Date.now() });
    }
  }

  // Nouvelle méthode pour nettoyer le cache et recharger
  clearCacheAndRefresh = () => {
    console.log('IframeV1: Nettoyage complet du cache et rechargement');
    
    // Réinitialiser l'état de chargement pour permettre un nouveau chargement
    this.setState({ 
      refreshTimestamp: Date.now(),
      hasLoadedOnce: false,
      isLoading: true,
      showIframe: false
    }, () => {
      console.log('IframeV1: Timestamp mis à jour, iframe va se recharger avec la nouvelle URL');
    });
  }

  // Méthode pour nettoyer complètement l'état de l'iframe
  clearIframeState = () => {
    if (this.iframeRef.current) {
      try {
        // Essayer de naviguer vers une page vide pour vider l'état
        this.iframeRef.current.src = 'about:blank';
        console.log('IframeV1: Iframe nettoyée avec about:blank');
        
        // Essayer de nettoyer le contenu de l'iframe si accessible
        const iframeDoc = this.iframeRef.current.contentDocument || this.iframeRef.current.contentWindow.document;
        if (iframeDoc) {
          iframeDoc.open();
          iframeDoc.write('');
          iframeDoc.close();
          console.log('IframeV1: Contenu iframe nettoyé');
        }
      } catch (error) {
        // En cas d'erreur CORS, on force just le src à about:blank
        console.log('IframeV1: Nettoyage limité par CORS, utilisation de about:blank uniquement');
        try {
          this.iframeRef.current.src = 'about:blank';
        } catch (e) {
          console.log('IframeV1: Impossible de nettoyer l\'iframe:', e);
        }
      }
    }
  }

  // Méthode statique pour nettoyer toutes les iframes de la page (utile pour le logout global)
  static clearAllIframes = () => {
    console.log('IframeV1: Nettoyage global de toutes les iframes');
    const allIframes = document.querySelectorAll('iframe');
    allIframes.forEach((iframe, index) => {
      try {
        iframe.src = 'about:blank';
        console.log(`IframeV1: Iframe ${index} nettoyée`);
      } catch (error) {
        console.log(`IframeV1: Erreur lors du nettoyage de l'iframe ${index}:`, error);
      }
    });
  }

  // Méthode statique pour forcer le rafraîchissement de toutes les iframes
  static refreshAllIframes = () => {
    console.log('IframeV1: Rafraîchissement global de toutes les iframes');
    const allIframes = document.querySelectorAll('iframe');
    allIframes.forEach((iframe, index) => {
      try {
        // Essayer de recharger l'iframe
        iframe.contentWindow?.location?.reload();
        console.log(`IframeV1: Iframe ${index} rafraîchie`);
      } catch (error) {
        // Si l'accès direct est bloqué, changer l'URL avec un timestamp
        const currentSrc = iframe.src;
        const separator = currentSrc.includes('?') ? '&' : '?';
        iframe.src = `${currentSrc}${separator}refresh=${Date.now()}`;
        console.log(`IframeV1: Iframe ${index} rafraîchie via changement d'URL`);
      }
    });
  }

  // Méthode pour forcer le rechargement sans about:blank
  forceReload = () => {
    console.log('IframeV1: Forçage du rechargement de l\'iframe');
    this.setState({ refreshTimestamp: Date.now() });
  }

  // Méthode pour forcer un rechargement complet avec nettoyage de cache
  forceCompleteReload = () => {
    console.log('IframeV1: Rechargement complet avec nettoyage de cache');
    
    // Réinitialiser complètement l'état pour éviter les rechargements multiples
    this.setState({ 
      isLoading: true,
      showIframe: false,
      hasLoadedOnce: false
    });
    
    // Nettoyer le cache du navigateur
    this.clearBrowserCache();
    
    if (this.iframeRef.current) {
      try {
        // Essayer de nettoyer le cache de l'iframe
        this.iframeRef.current.contentWindow.location.replace('about:blank');
        
        // Attendre un peu puis recharger avec la nouvelle URL
        setTimeout(() => {
          console.log('IframeV1: Rechargement avec la nouvelle URL après nettoyage');
          this.setState({ refreshTimestamp: Date.now() });
        }, 200); // Délai plus long pour permettre le nettoyage
        
      } catch (error) {
        console.log('IframeV1: Impossible de nettoyer le cache, rechargement simple');
        this.setState({ refreshTimestamp: Date.now() });
      }
    } else {
      console.log('IframeV1: Iframe pas encore montée, rechargement simple');
      this.setState({ refreshTimestamp: Date.now() });
    }
  }

  // Méthode pour nettoyer le cache du navigateur si possible
  clearBrowserCache = () => {
    console.log('IframeV1: Tentative de nettoyage du cache du navigateur');
    
    // Essayer de nettoyer le cache via l'API Cache si disponible
    if ('caches' in window) {
      caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          caches.delete(cacheName);
          console.log('IframeV1: Cache supprimé:', cacheName);
        });
      }).catch(error => {
        console.log('IframeV1: Erreur lors de la suppression du cache:', error);
      });
    }
    
    // Essayer de nettoyer le localStorage de l'iframe si possible
    try {
      if (this.iframeRef.current && this.iframeRef.current.contentWindow) {
        this.iframeRef.current.contentWindow.localStorage.clear();
        console.log('IframeV1: localStorage de l\'iframe nettoyé');
      }
    } catch (error) {
      console.log('IframeV1: Impossible de nettoyer le localStorage de l\'iframe (CORS)');
    }
  }

  // Gestionnaires d'événements pour diagnostiquer les problèmes
  handleIframeLoad = (e) => {
    console.log('IframeV1: Iframe chargée avec succès');
    console.log('IframeV1: URL chargée:', e.target.src);
    
    // Éviter les rechargements multiples
    if (this.state.hasLoadedOnce && !this.state.isLoading) {
      console.log('IframeV1: Iframe déjà chargée, ignorer ce chargement');
      return;
    }
    
    // Marquer comme chargé une fois
    this.setState({ hasLoadedOnce: true });
    
    // Vérifier immédiatement si l'iframe contient du contenu
    setTimeout(() => {
      try {
        const iframeDoc = e.target.contentDocument || e.target.contentWindow.document;
        if (iframeDoc && iframeDoc.body) {
          const bodyContent = iframeDoc.body.innerHTML;
          if (bodyContent.trim() === '') {
            console.warn('IframeV1: Iframe chargée mais contenu vide, garder le loader');
            // Garder le loader si le contenu est vide
            this.setState({ isLoading: true, showIframe: false });
            
            // Réessayer après un délai
            setTimeout(() => {
              this.checkIframeContent(e.target);
            }, 1000);
          } else {
            console.log('IframeV1: Iframe contient du contenu, afficher');
            // Afficher l'iframe seulement si elle contient du contenu
            this.setState({ showIframe: true, isLoading: false });
          }
        }
      } catch (error) {
        console.log('IframeV1: Impossible d\'accéder au contenu de l\'iframe (CORS)');
        // En cas d'erreur CORS, attendre un peu puis afficher
        setTimeout(() => {
          this.setState({ showIframe: true, isLoading: false });
        }, 1000);
      }
    }, 100); // Vérification rapide
  }

  // Méthode pour vérifier le contenu de l'iframe
  checkIframeContent = (iframe) => {
    try {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      if (iframeDoc && iframeDoc.body) {
        const bodyContent = iframeDoc.body.innerHTML;
        if (bodyContent.trim() !== '') {
          console.log('IframeV1: Contenu trouvé lors de la vérification');
          this.setState({ showIframe: true, isLoading: false });
        } else {
          console.log('IframeV1: Contenu toujours vide, continuer à attendre');
          // Réessayer encore
          setTimeout(() => {
            this.checkIframeContent(iframe);
          }, 1000);
        }
      }
    } catch (error) {
      console.log('IframeV1: Erreur lors de la vérification du contenu');
      // En cas d'erreur, afficher quand même après un délai
      setTimeout(() => {
        this.setState({ showIframe: true, isLoading: false });
      }, 2000);
    }
  }

  handleIframeError = (e) => {
    console.error('IframeV1: Erreur lors du chargement de l\'iframe');
    console.error('IframeV1: URL qui a échoué:', e.target.src);
    console.error('IframeV1: Détails de l\'erreur:', e);
    
    // Garder le loader en cas d'erreur
    this.setState({ isLoading: true, showIframe: false });
    
    // Essayer de recharger après un délai
    setTimeout(() => {
      console.log('IframeV1: Tentative de rechargement après erreur');
      this.setState({ refreshTimestamp: Date.now() });
    }, 2000);
  }

  render (){
    const { src, url, token, title, key, otherParam, hasSidebar = true, topOffset = 0, marginLeft = 16, marginRight = 16 } = this.props;
    const finalUrl = src || url; // Support des deux props pour compatibilité
    
    if (!finalUrl) {
      console.error('IframeV1: Aucune URL fournie (src ou url)');
      return <div>Erreur: Aucune URL fournie pour l'iframe</div>;
    }

    // Utiliser le token actuel du state ou celui des props
    const currentToken = this.state.currentToken || token;
    const fullUrl = `${URL_APP_V2}${finalUrl}${currentToken ? `?t=${currentToken}&` : "?"}nosidebar=true&ab=${this.state.refreshTimestamp}${otherParam || ''}`;
    
    // Calculer la position left en fonction de la présence de la sidebar et de la marge gauche
    const leftPosition = hasSidebar ? `calc(240px + ${marginLeft}px)` : `${marginLeft}px`;
    // Calculer la position right en fonction de la marge droite
    const rightPosition = `${marginRight}px`;
    // Calculer la position top en fonction de la sidebar et du topOffset (pour les tabs)
    const baseTop = hasSidebar ? 64 + 8 : 64;
    const topPosition = `calc(${baseTop}px + ${topOffset}px)`;
    
    console.log('IframeV1: URL générée:', fullUrl);
    console.log('IframeV1: Token utilisé:', currentToken);
    console.log('IframeV1: Props reçues:', { src, url, token, title, key, otherParam, hasSidebar, topOffset, marginLeft, marginRight });
    console.log('IframeV1: State actuel:', this.state);
    
    return(
      <>
        {/* Conteneur avec position fixed pour prendre toute la zone de contenu (avec marges) */}
        <div 
          className={`iframe-container-fixed ${hasSidebar ? 'with-sidebar' : 'no-sidebar'}`}
          style={{ 
            position: 'fixed',
            top: topPosition,
            left: leftPosition,
            right: rightPosition,
            bottom: '56px',
            overflow: 'hidden',
            display: 'block',
            zIndex: 1,
            transition: 'left 0.3s ease-in-out'
          }}
        >
          <style>{`
            .iframe-container-fixed {
              position: fixed !important;
              bottom: 56px !important;
              overflow: hidden !important;
              z-index: 1 !important;
            }
          `}</style>
          {/* Indicateur de chargement - même taille que l'iframe */}
          {this.state.isLoading && (
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
              borderRadius: '4px'
            }}>
              <div style={{
                width: '60px',
                height: '60px',
                border: '6px solid #f3f3f3',
                borderTop: '6px solid #3498db',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                marginBottom: '20px'
              }}></div>
              <div style={{ 
                color: '#666', 
                fontSize: '16px',
                fontWeight: '500',
                textAlign: 'center'
              }}>
                Chargement des données...
              </div>
              <div style={{ 
                color: '#999', 
                fontSize: '12px',
                marginTop: '8px',
                textAlign: 'center'
              }}>
                Veuillez patienter
              </div>
            </div>
          )}

          {/* Iframe avec contrôle de visibilité - cachée tant qu'elle n'a pas de contenu */}
          <iframe
            ref={this.iframeRef}
            key={key}
            src={fullUrl}
            title={title || "iframe"}
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-downloads allow-top-navigation-by-user-activation"
            onLoad={this.handleIframeLoad}
            onError={this.handleIframeError}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              opacity: this.state.showIframe ? 1 : 0,
              transition: 'opacity 0.3s ease-in-out',
              visibility: this.state.showIframe ? 'visible' : 'hidden',
              position: 'absolute',
              top: 0,
              left: 0,
              display: this.state.showIframe ? 'block' : 'none',
              overflow: 'hidden',
              minHeight: '0',
              maxHeight: '100%'
            }}
          ></iframe>
        </div>

        {/* CSS pour l'animation de chargement */}
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </>
    )
  }
}

// Exposer la classe globalement pour permettre l'accès depuis d'autres composants
if (typeof window !== 'undefined') {
  window.IframeV1 = IframeV1;
  
  // Méthode de diagnostic globale
  window.diagnoseIframe = () => {
    console.log('=== DIAGNOSTIC IFRAME ===');
    const allIframes = document.querySelectorAll('iframe');
    console.log('Nombre d\'iframes trouvées:', allIframes.length);
    
    allIframes.forEach((iframe, index) => {
      console.log(`--- Iframe ${index} ---`);
      console.log('URL:', iframe.src);
      console.log('Classe:', iframe.className);
      console.log('Visible:', iframe.offsetWidth > 0 && iframe.offsetHeight > 0);
      
      try {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        if (iframeDoc && iframeDoc.body) {
          const bodyContent = iframeDoc.body.innerHTML;
          console.log('Contenu:', bodyContent.trim() === '' ? 'VIDE' : 'PRÉSENT');
          console.log('Taille du contenu:', bodyContent.length, 'caractères');
        }
      } catch (error) {
        console.log('Accès au contenu bloqué (CORS)');
      }
    });
    
    console.log('Token localStorage:', localStorage.getItem('jwtToken_compta'));
    console.log('URL_APP_V2:', URL_APP_V2);
    console.log('========================');
  };

  // Méthode pour tester l'URL directement
  window.testIframeUrl = (url) => {
    console.log('=== TEST URL IFRAME ===');
    console.log('URL à tester:', url);
    
    // Créer une nouvelle iframe pour tester
    const testIframe = document.createElement('iframe');
    testIframe.src = url;
    testIframe.style.width = '100%';
    testIframe.style.height = '400px';
    testIframe.style.border = '2px solid red';
    
    testIframe.onload = () => {
      console.log('Test iframe chargée avec succès');
      try {
        const testDoc = testIframe.contentDocument || testIframe.contentWindow.document;
        if (testDoc && testDoc.body) {
          const bodyContent = testDoc.body.innerHTML;
          console.log('Contenu test:', bodyContent.trim() === '' ? 'VIDE' : 'PRÉSENT');
          console.log('Taille du contenu test:', bodyContent.length, 'caractères');
        }
      } catch (error) {
        console.log('Accès au contenu test bloqué (CORS)');
      }
    };
    
    testIframe.onerror = (error) => {
      console.error('Erreur lors du chargement de l\'URL test:', error);
    };
    
    // Ajouter temporairement à la page
    document.body.appendChild(testIframe);
    
    // Supprimer après 10 secondes
    setTimeout(() => {
      document.body.removeChild(testIframe);
      console.log('Test iframe supprimée');
    }, 10000);
    
    console.log('========================');
  };

  // Méthode pour forcer le rechargement de la page entière
  window.forcePageReload = () => {
    console.log('=== FORCE PAGE RELOAD ===');
    console.log('Rechargement forcé de la page entière...');
    window.location.reload(true); // true = rechargement avec nettoyage de cache
  };
}

export default IframeV1;
